import React from 'react';
import { Chip } from '@mui/material';

const styles = {
  root: {
    borderRadius: '0',
    borderColor: (theme) => theme.palette.primary.main,
    borderWidth: '2px',
  },
}

export default function AmploChip(props) {
  return (
    <Chip
      styles={{
        root: styles.root,
      }}
      {...props}
    />
  );
}